const fileUploadModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/segments/file-upload-modal/file-upload-modal.html',
  controller: 'FileUploadModalController',
};

angular
    .module('segments.module')
    .component('fileUploadModal', fileUploadModal);
